// extracted by mini-css-extract-plugin
export default {"pageloader":"PageLoader_pageloader__0o5KE"};